// This route matches the bare root path '/'
export default '/';
